import { useCallback } from 'react';

import * as releaseApi from 'api/releaseApi';
import { useToast } from 'hooks/useToast';
import { useAppDispatch, useAppSelector } from 'store/hooks/useStore';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import { listSelectors } from 'store/reducers/releaseReducers/releaseComponentReducer/listSlice';
import {
  editActions,
  editSelectors,
} from 'store/reducers/releaseReducers/releaseEnvironmentReducer/editSlice';
import { useListStore } from './useListStore';

export const useDeleteStore = () => {
  const componentList = useAppSelector(listSelectors.releaseComponents).map(
    (value) => ({ id: value.id, componentName: value.componentName }),
  );
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchReleaseEnvironments } = useListStore();
  const selectedReleaseEnvironment = useAppSelector(
    editSelectors.selectedReleaseEnvironment,
  );
  const isOpenModal = useAppSelector(editSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(editActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteEnvironment = useCallback(() => {
    if (selectedReleaseEnvironment) {
      const EnvironmentId = selectedReleaseEnvironment.manifestVersion || '';
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(editActions.updateLoadingStatus(true));
        const result = await releaseApi.deleteEnvironment(EnvironmentId);
        if (result.ok) {
          toast({
            status: 'success',
            description: `環境を削除しました。`,
          });

          onCloseModal();
          dispatch(editActions.modalOpened(null));
          void fetchReleaseEnvironments();
        } else {
          toast({
            status: 'error',
            description: `環境の削除に失敗しました。`,
          });
        }
        dispatch(editActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `環境の削除に失敗しました。`,
        });
      });
    }
  }, [
    selectedReleaseEnvironment,
    toast,
    dispatch,
    onCloseModal,
    fetchReleaseEnvironments,
  ]);

  return {
    /** 環境の内容 */
    values: selectedReleaseEnvironment || {
      name: '',
      components: [{ id: 0, version: '' }],
    },
    /** 環境の削除 */
    onDeleteEnvironment,
    /** 環境の削除キャンセル */
    onCloseModal,
    /** 環境削除確認モーダルの表示状態 */
    isOpenModal,
    componentList,
  };
};
